import { useQuery } from "react-query";
import { MRT_PaginationState } from "mantine-react-table";
import getExternalAccountConfig, {
  ExternalAccountConfigResponse,
} from "../services/getExternalAccountConfig";

function useGetExternalAccountConfig(
  token: string,
  pagination: MRT_PaginationState,
  columnFilters: string,
  sorting: string,
  globalFilter: string
) {
  return useQuery<ExternalAccountConfigResponse>({
    queryKey: ["get-external-account-config", pagination, columnFilters, sorting, globalFilter],
    queryFn: () =>
      getExternalAccountConfig({
        token,
        columnFilters,
        sorting,
        page: `${pagination.pageIndex + 1}`,
        pageSize: `${pagination.pageSize}`,
        globalFilter,
      }),
    retry: false,
    keepPreviousData: true,
    staleTime: 30_000,
  });
}

export default useGetExternalAccountConfig;
